import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import { useCookies } from 'react-cookie';
import S from './UspBar.styles';
const UspBar = (props) => {
    const cookieName = props.cookieName ?? 'notice-cookie';
    const [cookies, setCookie] = useCookies([cookieName]);
    if (props.barItems && props.barItems.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { id: props.id ?? props.anchorId, "data-background": props.theme, "data-type": props.contentType ?? ContentType.Default, "data-visible": !cookies[cookieName], translations: props.translations },
        props.barType === 'usp' && (React.createElement(S.Carousel, null,
            React.createElement(S.ItemArea, null,
                React.createElement(S.UspBarTrack, { "data-total": props.barItems?.length, style: {
                        '--speed': `${props.barItems?.length ? props.barItems.length * 7 : 0}s`,
                        '--count': props.barItems?.length ?? 0,
                    } },
                    props.barItems?.map((item, i) => (React.createElement(S.ItemHolder, { key: `item-${i}` },
                        React.createElement(S.ItemInner, null,
                            getSystemIcon(item.icon ?? SystemIcon.StarDocument),
                            ' ',
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: item.content } }))))),
                    props.barItems?.map((item, i) => (React.createElement(S.ItemHolder2, { key: `item-2-${i}` },
                        React.createElement(S.ItemInner, null,
                            getSystemIcon(item.icon ?? SystemIcon.StarDocument),
                            ' ',
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: item.content } }))))))))),
        props.barType === 'notice' && props.noticeItem && (React.createElement(S.Notification, null,
            React.createElement(S.NotificationInner, null,
                React.createElement(S.NoticeMain, null,
                    getSystemIcon(props.noticeItem?.icon ?? SystemIcon.Bell),
                    ' ',
                    React.createElement(S.NoticeContent, { dangerouslySetInnerHTML: { __html: props.noticeItem?.content } })),
                props.noticeLink && props.noticeLink.text && props.noticeLink.url && (React.createElement(S.LinkButton, { href: props.noticeLink.url, target: props.noticeLink.target, "aria-label": props.noticeLink.text },
                    props.noticeLink.text,
                    " ",
                    getSystemIcon(SystemIcon.ArrowRightThin)))),
            React.createElement(S.CloseBtn, { type: "button", "aria-label": "Dismiss Notice", onClick: () => setCookie(cookieName, true, { path: '/', maxAge: 24 * 60 * 60 }) }, getSystemIcon(SystemIcon.CloseCircle))))));
};
export default UspBar;
